import APIService from '@/services/APIService.js';

export default {
  status() {
    return APIService.apiCall().get('/auth/saml2/status');
  },

  jwtRecoveryKey(key) {
    return APIService.apiCall().get(`/auth/saml2/jwt-recovery-key/${key}`);
  }
};
